/** Reports is the sole consumer of commission rows. Authorization remains global. */
export function needsCommissionData(pathname: string) {
  const path = pathname.split(/[?#]/, 1)[0];
  return path === "/reports" || path.startsWith("/reports/");
}
